<template>
    <div class="aba-cliente select-modal">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column" :class="[permissaoCadastrar ? 'is-6' : 'is-8']">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-endereco"
                    />
                </div>

                <div class="column" :class="[permissaoCadastrar ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="!assClienteEnderecoIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastrarEndereco"
                    >
                        {{ $t('adicionar-endereco') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="AssEnderecoClienteList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'label'" class="label-container">
                            <div 
                                v-if="
                                    props.row.idendereco ==
                                    props.row.cliente.idenderecoentregapadrao
                                "
                                class="bar a-padrao" 
                                v-tippy 
                                :title="$t('entrega-padrao')"
                            />
                            <div 
                                v-if="
                                    props.row.idendereco ==
                                    props.row.cliente.idenderecocobrancapadrao
                                "
                                class="bar b-padrao" 
                                v-tippy 
                                :title="$t('cobranca-padrao')"
                            />
                        </div>
                        <div v-else-if="f.key == 'nome'">
                            <a @click="selectedEdit(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assClienteEnderecoIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'cnpjcpf' || f.key == 'ierg'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                showPartInfoPosition="end"
                                :showPartInfoLenght="4"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active="showModalAssociacao" custom-class="overflow" @close="promptChangeTab">
                <div class="bg overflow">
                    <EnderecoModal
                        :idCliente="+$route.params.id"
                        :idEndereco="this.idendereco"
                        :permissaoCadastrar="permissaoCadastrar"
                        @fecharModal="fecharModal"
                        v-if="showModalAssociacao"
                        @promptChangeTab="promptChangeTab"
                        @isChangedModal="isChangedModal = $event"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import EnderecoService from '@/services/vendas/cliente/abas/AssClienteEnderecoService';
import EnderecoModal from '@/components/vendas/cliente/modal/EnderecoModalManage.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';

// UTILS
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        EnderecoModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            assClienteEnderecoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ENDERECO'
            ),
            AssEnderecoClienteList: [],
            fields: [
                { key: 'label', width: 5, sortable: false, sortFn: null },
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
                { key: 'tipoendereco', width: null, sortable: true, sortFn: null },
                { key: 'cnpjcpf', width: null, sortable: false, sortFn: null },
                { key: 'ierg', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new EnderecoService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            assenderecocliente: null,
            cliente: {
                idenderecocobrancapadrao: 0,
                idenderecoentregapadrao: 0,
            },
            editentregapadrao: false,
            editcobrancapadrao: false,
            idendereco: 0,
            msgs: [],

            //permissoes relativas à exibição dos botões
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-endereco'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-endereco'
            );
        }

        this.permissaoCadastrar = this.permissao.create && !this.assClienteEnderecoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.AssEnderecoClienteList = value;
                    this.isEmpty = this.AssEnderecoClienteList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os endereços!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, id, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idendereco: m.idendereco,
                    codigo: m.idenderecoerp,
                    idcliente: m.idcliente,
                    idtipoendereco: m.idtipoendereco,
                    tipoendereco: m.tipoendereco.descricao,
                    nome: m.nome,
                    rsocial: m.rsocial,
                    cnpjcpf: m.cnpjcpf,
                    ierg: m.ierg,
                    replicapda: m.replicapda,
                    cliente: {
                        idenderecoentregapadrao: m.cliente.idenderecoentregapadrao,
                        idenderecocobrancapadrao: m.cliente.idenderecocobrancapadrao,
                    },
                    editentregapadrao: m.editentregapadrao,
                    editcobrancapadrao: m.editcobrancapadrao,

                    isChangedModal: false,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let tempAssClienteEndereco = {
                idendereco: this.delete.idendereco,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };
            let message = null;

            this.find(tempAssClienteEndereco.idendereco).then((value) => {
                if (
                    tempAssClienteEndereco.replicapda == 2 &&
                    (tempAssClienteEndereco.idendereco ==
                        value.content.cliente.idenderecocobrancapadrao ||
                        tempAssClienteEndereco.idendereco ==
                            value.content.cliente.idenderecoentregapadrao)
                ) {
                    message = this.$t('msg-confirmacao-desativacao-endereco-padrao', { n: row['nome'] });
                    this.$root.confirm({
                        message: message,
                        onConfirm: () => this.atualizarEnderecoCliente(this.delete),
                        onCancel: () => this.removePrompt,
                    });
                } else {
                    message = this.$t(
                            row.replicapda == 3
                                ? 'msg-confirmacao-desativacao-n'
                                : 'msg-confirmacao-reativacao-n', 
                            { n: row['nome'] }
                        );
                    this.$root.confirm({
                        message: message,
                        onConfirm: () => this.updateSituacaoRegistro(),
                        onCancel: () => this.removePrompt,
                    });
                }
            });
        },
        find(idendereco) {
            if (this.isVenda) return this.service.findVendas(idendereco);
            else return this.service.findAgro(idendereco);
        },
        atualizarEnderecoCliente(endereco) {
            let enderecoTemp = {
                cliente: {
                    idenderecocobrancapadrao: 0,
                    idenderecoentregapadrao: 0,
                },
                idendereco: endereco.idendereco,
                idcliente: endereco.idcliente,
                replicapda: endereco.replicapda,
                editcobrancapadrao: false,
                editentregapadrao: false,
            };
            if (endereco.cliente.idenderecocobrancapadrao == endereco.idendereco) {
                enderecoTemp.cliente.idenderecocobrancapadrao = 0;
                enderecoTemp.editcobrancapadrao = true;
            }
            if (endereco.cliente.idenderecoentregapadrao == endereco.idendereco) {
                enderecoTemp.cliente.idenderecoentregapadrao = 0;
                enderecoTemp.editentregapadrao = true;
            }

            this.service.atualizaEnderecoPadrao(enderecoTemp).then((value) => {
                if (value.message == null) {
                    this.msgs.push(new Message('success', 'msg-endereco-padrao-alterado', true));
                    this.updateSituacaoRegistro();
                } else {
                    if (this.$t(value.message)) {
                        this.msgs.push(new Message('alert', value.message, true));
                    } else {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    }
                }
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-cliente-endereco'
                    : 'msg-erro-ao-reativar-associacao-cliente-endereco';

            let tempAssClienteEndereco = {
                idendereco: this.delete.idendereco,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssClienteEndereco)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-cliente-endereco'
                                : 'msg-sucesso-ao-desativar-associacao-cliente-endereco';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assClienteEndereco) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assClienteEndereco);
            else return this.service.updateSituacaoAgro(assClienteEndereco);
        },
        showModalCadastrarEndereco() {
            this.idendereco = null;
            this.assenderecocliente = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        promptChangeTab() {
            if (this.isChangedModal) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.fecharModal();
                    },
                });
            } else {
                this.fecharModal();
            }
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.assenderecocliente = null;
            this.carregarDados();
        },
        selectedEdit(select) {
            this.idendereco = select.idendereco;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    .label-container {
        display: flex;
        flex-direction: row;

        .bar {
            height: auto !important;
            bottom: -25px;
        }

        > div {
            width: 10px;
        }

        .label-km {
            padding-left: 0;
            padding-right: 0;
        }
        .bar {
            border-radius: 100px;
            width: 5px;
            height: 26px;
            position: absolute;
            top: -17px;
            &.a-padrao {
                background-color: #5f971e;
            }
            &.b-padrao {
                background-color: #891e97;
            }
        }
        .bar-column {
            padding-left: 0.01rem;
            padding-right: 0.01rem;
        }
    }

    @media (max-width: 760px) {
        .label-km {
            padding-left: 5px;
            padding-right: 20px;
            justify-content: left;
        }
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
